import { BoardData } from '../components/board/boardTypes';
import localBoardData from '../components/board/boardMembersData.json';

import { GOOGLE_API_KEY } from './constants';

export const fetchBoardData = async (fileId: string): Promise<BoardData> => {
  if (!GOOGLE_API_KEY) {
    console.warn('🔑 Google API key not found, using local board data');
    return localBoardData as BoardData;
  }

  try {
    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📋 Successfully loaded board data from Google Drive');
    return data as BoardData;
  } catch (error) {
    console.warn(
      '⚠️ Error fetching board data from Drive, using local data:',
      error
    );
    return localBoardData as BoardData;
  }
};
